// extracted by mini-css-extract-plugin
module.exports = {"body":"filter-modal_body__a3aRR","footer":"filter-modal_footer__oT_t_","cancel":"filter-modal_cancel__444xj"};